import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {BeatLoader} from "react-spinners";
import { override } from '../helpers/utils.js';
import jwt_decode from "jwt-decode";
class CustomerVPA1 extends Component{
    constructor(props) {
        super(props);
        this.state ={
            CustomerVPAID:'',
            CustomerVPAList:[{value: '', label: 'Select'}],
            is_CustomerVPA_loading: true,
            CustomerVPAValue: [],
            CustomerVPAListOpen: false,
            CustomerVPAHeaderTitle: "Select [CustomerVPA]",
            object_code:[],
            CustomerVPAObject:[],
            search_object_code:[],
            CustomerVPA_name:""

        }
        this.closeCustomerVPAList = this.closeCustomerVPAList.bind(this);
    }

    componentDidUpdate() {
        const { CustomerVPAListOpen } = this.state;
        setTimeout(() => {
            if (CustomerVPAListOpen) {
                window.addEventListener('click', this.closeCustomerVPAList);
            } else {
                window.removeEventListener('click', this.closeCustomerVPAList);
            }
        }, 0);
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            userGroupName:decoded.userGroupName,
            object_code:decoded.object_code,
            object_type:decoded.object_type
        })
        this.getCustomerVPA(decoded.object_type,arrayCode,false,'',this.props.start_date,this.props.end_date);
    }
    restCustomerVPAFilter(){
        this.setState({
            CustomerVPAID: [],
        })
    }
    getCustomerVPA(object_type, object_code,is_search, search_value,start_date, end_date) {
        //alert(code); alert(type)
        if(is_search===false){
            this.setState({
                CustomerVPAID:[]
            })
        }
        this.setState({
//             search_code: code,
//             search_type: type,
            object_type: object_type,
            search_object_code: object_code
        })
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.CustomerVPAObject
        }
        this.setState({
            CustomerVPAList:[],
            is_CustomerVPA_loading: true
        })
        var url = '/filters/get-txn-summary-filters';

        axios.post(config.get('API_URL')+url, {
                user_type: object_type,
                object_code: object_code,
                filter_type: "Customer_VPA",
                is_search: is_search,
                search_value: search_value,
                start_date: start_date,
                end_date: end_date,
                is_current_date: this.props.is_current_date,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then((response) => {
                let CustomerVPAList = [];
                //this.setState({CustomerVPAID:''});
                console.log('Response**',response)
                response.data.map((CustomerVPA,index) => {
                    CustomerVPAList.push({value: CustomerVPA['customer_vpa'], label: CustomerVPA['customer_vpa']})
                });
                let res = []
                if (Array.isArray(this.state.CustomerVPAID) && this.state.CustomerVPAID) {
                    const uniq = new Set(CustomerVPAList.map(e => JSON.stringify(e)));

                    CustomerVPAList = Array.from(uniq).map(e => JSON.parse(e));

                }
                this.setState({
                    CustomerVPAList:CustomerVPAList,
                    is_CustomerVPA_loading: false
                })
            }).catch((e)=>{
                console.log(e)
                this.setState({
                    is_CustomerVPA_loading: false
                })
            })
    }
    changeCustomerVPA(login_type, CustomerVPA_object, checked_item, e) {
        if (login_type === 'CustomerVPA') {
            let value='';
            let sidArray = [];
            if(CustomerVPA_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                CustomerVPA_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            this.setState({
                CustomerVPAID: sidArray,
                CustomerVPAValue:CustomerVPA_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: true
            });
        } else {
            let item_list = this.state.CustomerVPAID;
            let item_list_object = this.state.CustomerVPAObject;
            let checked_list = CustomerVPA_object.value;
            let checked_list_object = CustomerVPA_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [CustomerVPA_object, ...this.state.CustomerVPAList.filter(item => item !== CustomerVPA_object)];
                this.setState({
                    CustomerVPAID: [...this.state.CustomerVPAID,CustomerVPA_object.value],
                    CustomerVPAObject: [...this.state.CustomerVPAObject,CustomerVPA_object],
                    isChange: true,
                    CustomerVPAList: newData,
                    CustomerVPA_name: CustomerVPA_object.label,

                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        CustomerVPAID: item_list,

                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        CustomerVPAObject: item_list_object,
                        isChange: true
                    })
                }
            }
            setTimeout(function() {
                this.props.onSelectCustomerVPA(this.state.CustomerVPAID);
            }.bind(this), 200);
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

    }
    removeCustomerVPA(){
        const val = ''
        this.props.onSelectCustomerVPA(val);
        this.setState({
            CustomerVPAValue:[],
            CustomerVPAID:'',
            CustomerVPA_name:''
        });
    }
    CustomerVPAToggleList() {
        this.setState({
            CustomerVPAListOpen: !this.state.CustomerVPAListOpen,
        });
    }
    CustomerVPAFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getCustomerVPA(this.state.object_type, this.state.search_object_code,true, value,this.props.start_date,this.props.end_date);
        }.bind(this), 200);
    }
    closeCustomerVPAList() {
        this.setState({
            CustomerVPAListOpen: false,
        });
    }

    render() {
        //console.log(this.state.CustomerVPA_name);
        const CustomerVPA_lists = this.state.CustomerVPAList.map((CustomerVPA_object, index) => {
            // console.log("CustomerVPA_object");
            // console.log(CustomerVPA_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.CustomerVPAID.includes(CustomerVPA_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeCustomerVPA.bind(this, '', CustomerVPA_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{CustomerVPA_object.label}
                </li>
            )
        })

        return(

            <div className="dd-wrapper">
                <div className="dd-header" onClick={() => this.CustomerVPAToggleList()}>
                    {this.state.CustomerVPAID==''?
                        <div className="dd-header-title">{this.state.CustomerVPAHeaderTitle}</div>:
                        <div className="dd-header-title">{this.state.CustomerVPAID.length} Selected</div>
                    }


{/*                     {this.state.CustomerVPAListOpen===false? */}
                        <i className="fa fa-angle-down"></i>
{/*                     } */}
                </div>

                {this.state.CustomerVPAListOpen ===true?
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            onChange={(e) => this.CustomerVPAFilterList(e)}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        {/*<div className="dd-scroll-list">*/}
                        <ul className="dd-list">
                            {this.state.is_CustomerVPA_loading===true?
                                <li>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_CustomerVPA_loading}
                                    />
                                </li>: null}
                            {CustomerVPA_lists}

                        </ul> </div>: null }
                {/*</div>*/}
            </div>

        );
    }
}

export default CustomerVPA1;